module.exports = __webpack_public_path__ + "img/testibg.aad98f40.webp";